interface WeatherProps {
  onNavigate: (to: string) => void;
}

interface GameEntry {
  slug: string;
  name: string;
  blurb: string;
}

const GAMES: readonly GameEntry[] = [
  {
    slug: "flashcards",
    name: "Flash cards (term → meaning)",
    blurb:
      "Read a Met Office forecast term, pick the exact range it covers. Beaufort numbers, sea state, visibility, timing.",
  },
  {
    slug: "reverse",
    name: "Flash cards (range → term)",
    blurb:
      "Read a wind speed / wave height / time window, pick the term a Met Office forecast would use.",
  },
  {
    slug: "synoptic",
    name: "Synoptic recognition",
    blurb:
      "Mixed drill on the Day Skipper theory material — front types from cloud sequences and wind shifts, pressure features from isobar patterns, fog types from formation conditions, cloud genera from appearance.",
  },
];

export function Weather({ onNavigate }: WeatherProps) {
  return (
    <>
      <p className="muted">
        UK Met Office Shipping Forecast + Inshore Waters Forecast terminology
        with the exact ranges each term covers. The full glossary — Beaufort
        numbers, sea state, visibility, timing — lives on the Reference tab;
        play the flashcards to drill until you can decode a forecast at a glance.
      </p>

      <h2 style={{ marginTop: 24 }}>Games</h2>
      {GAMES.map((g) => (
        <div key={g.slug} className="card">
          <h3 style={{ marginBottom: 4 }}>{g.name}</h3>
          <p className="small muted" style={{ marginBottom: 12 }}>
            {g.blurb}
          </p>
          <button
            onClick={() => onNavigate(`/play/weather/${g.slug}`)}
            className="secondary"
          >
            Play
          </button>
        </div>
      ))}
    </>
  );
}
